/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heroic_Day_Ocelot_BlinkInputs */

const fr_heroic_day_ocelot_blink = /** @type {(inputs: Heroic_Day_Ocelot_BlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

/**

* @param {Heroic_Day_Ocelot_BlinkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const heroic_day_ocelot_blink = /** @type {((inputs?: Heroic_Day_Ocelot_BlinkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heroic_Day_Ocelot_BlinkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_heroic_day_ocelot_blink(inputs)
});